import { globalMatrix } from "../globals";

export { ServerStorageMobile };

class ServerStorageMobile {
    private Server: string;
    constructor() {
        this.Server = globalMatrix.matrixBaseUrl + "_";
    }
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    setItem(itemKey: string, itemVal: string) {
        localStorage.setItem(this.Server + itemKey, itemVal);
    }
    getItem(itemKey: string): string {
        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
        return localStorage.getItem(this.Server + itemKey);
    }
    getItemDefault(itemKey: string, defaultValue: string): string {
        let s = localStorage.getItem(this.Server + itemKey);
        return s ? s : defaultValue;
    }
}
